export default "__VITE_PUBLIC_ASSET__606359bc__"